import { useNavigate } from "react-router-dom";
import MTable from "../../../components/mtable";
import { formatEnum } from "../../../utils/strings";
import { getStorage, STORAGE } from "../../../utils/storage";

export default function Questionnaires() {

    const navigate = useNavigate()
    const isAdmin = getStorage(STORAGE.IS_ADMIN)
    const isCM = getStorage(STORAGE.USER_ROLE) === 'CompanyManager'
    const canCreate = isAdmin || isCM
    const create = () => navigate('create')

    const questioneersMapper = {columns: [
        {
            label: "Name",
            style: "full",
            value: (item) => item.name
        },
        {
            label: "Questions Count",
            value: (item) => item.questionsCount,
            width: "0.5fr"
        },
        {
            label: "Status",
            value: (item) => item?.status ? formatEnum(item?.status ?? '') : '--'
        },
        ...((isAdmin || isCM) ? [{
            label: "",
            actions: [
                {
                    label: "Duplicate",
                    style: (_) => "outline",
                    onClick: (item) => navigate(`duplicate/${item.id}`)
                }
            ],
            width: "100px"
        }] : [])
    ]}

    const handleClick = (item) => {
        if (item.status == "Published") navigate(`${item.id}`)
        else navigate(`create/${item.id}`)
    }

    return(<div className="page-xl-centered standard-padding showing">
        <div className="flex space-between gap-xs center v-spacer-m">
            <p className="section-title">Questionnaires</p>
            {canCreate && <button className="solid" onClick={create}>Create Questionnaire</button>}
        </div>
        <MTable path={'questionnaires'} mapper={questioneersMapper} onClick={handleClick}/>
    </div>)
}